import { useEffect } from 'react';
import { useAuth } from '../contexts/auth/useAuth';
import { useApi } from '../hooks/api/useApi';
import { loadZendesk } from '../services/zendesk';

function ZendeskWidgetAuthenticator() {
  const { isAuthenticated } = useAuth();
  const { makeApiRequest } = useApi();

  useEffect(() => {
    if (!isAuthenticated) return;

    const jwtFn = (callback: (jwt: string) => void) => {
      makeApiRequest<{ jwt: string }>('/auth/zendesk-widget-jwt', 'GET')
        .then((data) => callback(data.jwt))
        .catch((err) => console.error('Zendesk widget JWT fetch failed:', err));
    };

    loadZendesk(jwtFn).catch((err) =>
      console.error('Zendesk widget init failed:', err)
    );
  }, [isAuthenticated, makeApiRequest]);

  return null;
}

export default ZendeskWidgetAuthenticator;
